module.exports = __webpack_public_path__ + "img/nic-asia-bank.a2fc937b.png";